import(/* webpackMode: "eager", webpackExports: ["Hydrate","useHydrate"] */ "/app/node_modules/@tanstack/react-query/build/lib/Hydrate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/lib/isRestoring.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["unstable_batchedUpdates"] */ "/app/node_modules/@tanstack/react-query/build/lib/reactBatchedUpdates.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsMutating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/lib/useMutation.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/useQueries.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQuery.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["useGetCompanyQuery"] */ "/app/src/api/AppApi/services/company/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-builder/banner_slider/helpers/SliderCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/blog/BlogsCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/BlogCategory/BlogCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CategoriesSkeleton","BlogsSkeleton"] */ "/app/src/app/components/common-builder/BuilderSkeletons.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/calendar-service/CalendarService.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/Category/Categories.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/consultation-service/ConsultationBox.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/feature-box/FeatureBoxes.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/gallery/Galleries.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/pop-ups-components/Product-Details-pop-up/ProductDetailsPopUp.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/pop-ups-components/Product-price-info-pop-up/ProductPriceInfoPopUp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-builder/pop-ups-components/scrollable-tab/ProductTabsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-builder/pop-ups-components/scrollable-tab/TabsContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-builder/product-tabs/tabs/Tabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/product/product-carousel/ProductCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/product/product-grids/ProductGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-builder/product/product-grids/ProductGridWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/common-builder/products-bundle/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common-filter-builder/filter/mobile-filter/SvgFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/common/PageScrollRestore.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/lib/breadcrumb/BreadCrumb.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/lib/navigation/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/lib/ProgressiveImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/pages-components/brand-page/BrandDetailsBlackBox.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/pages-components/cart/crosssell/CartCrossSellPopupHost.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/pages-components/common/go-to-cart-pop-up/GoToCartPopUp.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/review-product/review-form/ReviewsFormModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/review-product/ReviewsModal/ProductReviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/delivery-header/DeliveryHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/fab/Fab.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/footer/footer-helpers/FooterPaymentMethods.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/header-common/CompanyMenus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/CurrencyChanger/CurrencyChanger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/Logout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/menu/MenuItem.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/header-common/PcHeaderTail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/search/NewHeaderSsearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/search/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/signin-btn/SigninBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/header-common/UserMenuContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/HeaderTypeSetter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/mobile-header/mobile-header-helpers/mobile-header-icons/SvgGoBack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/mobile-header/mobile-header-helpers/mobile-header-icons/SvgMobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/mobile-header/mobile-header-helpers/MobileHeaderHeightSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/mobile-header/side-menu/SideMenuContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/mobile-header/side-menu/SideMenuFavorites.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/pc-header/helpers/pc-cart-btn/PcCartMenu.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/pc-header/helpers/pc-favorites-btn/FavoritesButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/layouts/header/pc-header/helpers/SearchPart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/pc-header/MegaPcHeader/MegaMenuItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/header/pc-header/MegaPcHeader/MegaNavScroller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/mobile-layout/mobile-layout-helpers/SvgCartLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/mobile-layout/mobile-navigator/MobileNavigator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/mobile-layout/mobile-navigator/navigator-icons/SvgBarSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/layouts/toggle-switch/LanguageSwitch.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/bootstrap/index.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/ScriptInject.tsx");
